import { Column } from "@tanstack/react-table";
import { cn } from "@/lib/utils";
import { useTableSortOption } from "./data-table-context";
import { DataTableSortArrow } from "./data-table-sort-arrow";

interface DataTableColumnHeaderProps<TData, TValue>
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  column: Column<TData, TValue>;
  title: React.ReactNode;
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  const { sortEnum } = useTableSortOption();

  // Determine if column can be sorted.
  // It must be enabled by tanstack config AND its id must exist in the sortEnum.
  const isSortable =
    column.getCanSort() &&
    (sortEnum as unknown as string[] | undefined)?.includes(column.id);

  if (!isSortable) {
    return <div className={cn("text-sm font-medium", className)}>{title}</div>;
  }

  return (
    <div className={cn("flex items-center space-x-2", className)}>
      <button
        type="button"
        onClick={column.getToggleSortingHandler()}
        className="group flex cursor-pointer items-center text-sm font-medium hover:text-foreground/80 outline-none"
      >
        <span>{title}</span>
        <DataTableSortArrow sortDirection={column.getIsSorted()} />
      </button>
    </div>
  );
}
